module.exports = __webpack_public_path__ + "img/smart-m-2.8a2dfc2c.jpg";